/*
 *
 * Session reducer
 *
 */

import {
  MY_ACCOUNT_LIST,
  MY_ACCOUNT_LIST_SUCCESS,
  MY_ACCOUNT_LIST_ERROR,
  DASHBOARD_ME_API,
  DASHBOARD_ME_API_ERROR,
  DASHBOARD_ME_API_SUCCESS
  
} from "./constants";

const initialState = {
  loading: false,
  success: false,
  error: false,
  loggedIn: true,
  metaData: {},
  user: {},
};

/**
 * @param {object} state
 * @param {object} action
 */
const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case MY_ACCOUNT_LIST:
      return {
        ...state,
        loading: true,
      };
      case DASHBOARD_ME_API:
        return {
          ...state,
          loading:true
        }

    case MY_ACCOUNT_LIST_SUCCESS:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        account_List: action.account_List,
      };
   
    case DASHBOARD_ME_API_SUCCESS:
      return {
        loading: false,
        success: false,
        error: false,
        loggedIn: true,
        dashboar_Data: action.dashboar_Data,
      };
   
    case MY_ACCOUNT_LIST_ERROR:
      return {
        loading: false,
        success: false,
        error: true,
        loggedIn: false,
        account_List: false,
      };

    case DASHBOARD_ME_API_ERROR:
      return {
        loading: false,
        success: false,
        error: true,
        loggedIn: false,
        dashboar_Data: false,
      };
    default:
      return state;
  }
};

export default sessionReducer;
